import React, { useState } from "react";
import { EditSectionTemplate } from "components/MainSectionTemplate/EditSectionTemplate";
import { TagInfo } from "./models";
import { routes } from "utilities/routing/generatedRoutes";
import RequiredTextInput from "components/ValidatedFields/RequiredTextInput";
import { ColorPicker } from "components";

interface TagNewSectionProps {
  mainArea: server.dto.MainAreas
}

export const TagNewSection = (props: TagNewSectionProps) => {
  const { mainArea } = props;
  const [value, setValue] = useState<TagInfo>({
    title: "",
    hexColor: "",
    code: ""
  });

  const onChange = (newData: Partial<TagInfo>) => {
    setValue({ ...value, ...newData });
  };

  return <EditSectionTemplate
    submit={() => window.CoreApi.Tag.Create({
      title: value.title,
      hexColor: value.hexColor,
      code: value.code,
      mainArea
    })}
    redirectUrl={(itemId) => routes.tag_Detail(itemId).absolute}
    sections={[{
      type: "regular",
      key: "tag",
      title: RESX.Tag.resxTag,
      fields: [{
        key: "title",
        label: RESX.GeneralLabels.Title,
        renderEditNew: () => <RequiredTextInput
          validatorKey="title"
          maxLength={serverReference.constants.tag.maxTitleLength}
          value={value.title}
          onChange={(title) => { onChange({ title }); }}
        />,
      }, {
        key: "code",
        label: RESX.Tag.DisplayInList,
        renderEditNew: () => <RequiredTextInput
          validatorKey="code"
          maxLength={serverReference.constants.tag.maxCodeLength}
          value={value.code}
          onChange={(code) => { onChange({ code }); }}
        />,
      }, {
        key: "color",
        label: RESX.GeneralLabels.resxColor,
        renderEditNew: () => <div className="main-section-template-fields-padding">
          <ColorPicker
            value={value.hexColor}
            onChange={(c) => { onChange({ hexColor: c }); }}
          />
        </div>,
      }],
    }]}
  />;
}